import { Id } from '@resident-select/domain/core';
import { DynamicPermissionEntity } from '@resident-select/domain/dynamic-permission';

export interface DynamicPermissionState {
  dynamicPermissions: Record<Id, DynamicPermissionEntity>;
  dynamicPermissionsByQuery?: Id[];
}

export const initialAuthState: DynamicPermissionState = {
  dynamicPermissions: {},
};
